import React, { useContext, useEffect } from 'react'
import { HeadingContext } from '../context/HeadingContext';

function Users() {

  const { setHeading } = useContext(HeadingContext);

  useEffect(() => {
    setHeading('Users');
  }, [setHeading]);


  return (
    <div>Users</div>
  )
}

export default Users